import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetMainArticlesFailed, EGetMainArticlesActionType } from './types';

export const getMainArticlesFailed: () => TGetMainArticlesFailed = actionGenerator<EGetMainArticlesActionType.Failed>(
  EGetMainArticlesActionType.Failed,
);
